import { render, staticRenderFns } from "./teacherDetails.vue?vue&type=template&id=4ea6c05e&scoped=true&"
import script from "./teacherDetails.vue?vue&type=script&lang=js&"
export * from "./teacherDetails.vue?vue&type=script&lang=js&"
import style0 from "./teacherDetails.vue?vue&type=style&index=0&id=4ea6c05e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea6c05e",
  null
  
)

export default component.exports